const api = {
	getToken: 'system/getLargeScreen',
	getWnSysSet: 'CompanyWebsite/wnSysSet/getWnSysSet',
	getwnBanner: 'CompanyWebsite/wnBanner/list',
	getwnCompHonor: 'CompanyWebsite/wnCompHonor/list',
	getNews: 'CompanyWebsite/wnNews/list',
	getByNews: 'CompanyWebsite/wnNews/getByNewsId',
	getCase: 'CompanyWebsite/wnCase/list',
	getByCase: 'CompanyWebsite/wnCase/getByCaseId',
	getInfo: 'CompanyWebsite/userRequestInfo/saveUserRequestInfo',

}

export default api


// WEBPACK FOOTER //
// ./src/api/index.js